import React from 'react';
import type { FAQPage, WithContext } from 'schema-dts';

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQPageSchemaProps {
  faqItems: FAQItem[];
  pageUrl?: string;
}

export function FAQPageSchema({ faqItems, pageUrl }: FAQPageSchemaProps) {
  // Defensive check: ensure faqItems is valid
  if (!faqItems || !Array.isArray(faqItems) || faqItems.length === 0) {
    return null;
  }

  const schema: WithContext<FAQPage> = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    ...(pageUrl && { "@id": pageUrl }),
    "mainEntity": faqItems.map((item) => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer
      }
    }))
  };

  // Render script tag directly in component (server-side rendered)
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema, null, 2) }}
    />
  );
}
